export default __webpack_public_path__ + "static/media/icon-leaf-orange.9381a14b.svg";